<template>
  <div class="filter-badge">
    <span class="filter-badge__description">
      <slot name="description" />
    </span>
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseFilterBadge"
};
</script>

<style lang="scss" scoped>
.filter-badge {
  border: 1px solid $color-grey-100;
  padding: 6px 10px;
  margin: 0 5px 5px;

  &__description {
    color: $color-grey-400;
  }
}
</style>
